import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import ApplicationLayout from "../../layouts/ApplicationLayout"
import LoadingError from "../../components/shared/LoadingError"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import Recalls from "../../components/dashboard/Recalls"

class RecallIndex extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoadingError: PropTypes.bool.isRequired,
    vehicles: PropTypes.array.isRequired
  }

  async componentWillMount() {
    this.loading = true
    await this.fetchDashboardData()
    this.loading = false
  }

  fetchDashboardData() {
    this.props.dispatch({
      type: "DASHBOARD_LOAD_SAGA",
      payload: {
        users: ["id", "firstName", "lastName"],
        vehicles: [
          "id",
          "license_plate_number",
          "license_plate_state",
          "make",
          "model",
          "year",
          "recalls",
          "other_id"
        ]
      }
    })
  }

  shouldRenderContent() {
    const { isLoading, isLoadingError } = this.props

    return !isLoading && !isLoadingError && !this.loading
  }

  renderContent() {
    const { vehicles } = this.props

    if (this.shouldRenderContent()) {
      return (
        <div className={"dash-recalls-container"}>
          <div className={"dash-hd"}>RECALLS</div>

          <Recalls vehicles={vehicles} />
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    const { isLoading, isLoadingError } = this.props

    return (
      <ApplicationLayout>
        <LoadingThrobber visible={isLoading} />

        <LoadingError visible={!isLoading && isLoadingError} />

        {this.renderContent()}
      </ApplicationLayout>
    )
  }
} // class RecallIndex

const mapStateToProps = (state) => ({
  isLoading: state.application.isLoading,
  isLoadingError: state.application.isLoadingError,
  vehicles: state.vehicles.vehicles
})

export default connect(mapStateToProps)(RecallIndex)
